import styled from 'styled-components';
import { buttonSize } from '../AddButton';

export default styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: contain;
  text-align: center;
  display: grid;
  align-content: center;
  justify-content: center;
  text-decoration: none;
  padding-right: 5px;
`;
